import React, {Component} from 'react';

import HeroContainer from './bpeel/HeroContainer';
import WhatIsBPeel from './bpeel/WhatIsBPeel';
import WhoIsItFor from './bpeel/WhoIsItFor';
import Treatments from './bpeel/Treatments';
import HAPComparisonContainer from './bpeel/HAPComparisonContainer';
import BPeelPoster from './bpeel/BPeelPoster';

class PhytoContainer extends Component {
  render() {
    return (
      <div className="phyto">
        <HeroContainer />
        <BPeelPoster />
        <WhatIsBPeel />
        <WhoIsItFor />
        <Treatments />
        <HAPComparisonContainer />
      </div>
    )
  }
}

export default PhytoContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/PhytoContainer.jsx
 **/